import { otpHost } from 'config/env.conf';
import verify from 'views/notification/verify.vue'
import vendorsViolationVerify from 'views/notification/vendorsViolationVerify.vue'
import broadcast from 'views/notification/broadcast.vue'
import Main from 'views/layout/Main.vue'
import { businessLines } from 'data/notification'

const baseUrl = `${otpHost}/#/notification/`

export default [
    {
        name: 'verify',
        path: 'verify',
        component: verify,
        meta: {
            title: '审核消息',
            src: baseUrl,
            icon: 'check-circle'
        }
    },
    {
        name: 'vendorsViolationVerify',
        path: 'vendorsViolationVerify',
        component: vendorsViolationVerify,
        meta: {
            title: '违规消息',
            src: baseUrl,
            icon: 'check-circle'
        }
    },
    {
        name: 'broadcast',
        path: 'broadcast',
        component: Main,
        meta: {
            title: '平台公告',
            icon: 'volume-up'
        },
        children: [
            ...businessLines.map(line => {
                return {
                    name: 'broadcast' + line.value,
                    path: line.value,
                    component: broadcast,
                    meta: {
                        title: line.name + '平台公告',
                        src: `${baseUrl}broadcast/`,
                        bizLineId: line.bizLineId
                    }
                }
            })
        ]
    },
];


// WEBPACK FOOTER //
// ./src/router/router.notification.js